export function getTranslationsPage2(
  newNameCitizenshipDetails,
  localizedStrings,
) {
  newNameCitizenshipDetails.lastname.elementConfig.label =
    localizedStrings.applicationpage.legallastname;
  newNameCitizenshipDetails.firstname.elementConfig.label =
    localizedStrings.applicationpage.legalfirstname;
  newNameCitizenshipDetails.middlename.elementConfig.label =
    localizedStrings.applicationpage.legalmiddlename;
  newNameCitizenshipDetails.ses_preferredname.elementConfig.label =
    localizedStrings.applicationpage.preferredname;
  newNameCitizenshipDetails.usb_maidenname.elementConfig.label =
    localizedStrings.applicationpage.birthname;
  newNameCitizenshipDetails.usb_formername.elementConfig.label =
    localizedStrings.applicationpage.formername;
  newNameCitizenshipDetails.usb_visastatus.elementConfig.label =
    localizedStrings.applicationpage.citizenshipstatus;
  newNameCitizenshipDetails.usb_currentstudent.elementConfig.label =
    localizedStrings.applicationpage.usbstudent;
  newNameCitizenshipDetails._usb_countryofcitizenship_value.elementConfig.label =
    localizedStrings.applicationpage.countryofcitizenship;
  newNameCitizenshipDetails._usb_countryofbirth_value.elementConfig.label =
    localizedStrings.applicationpage.countryofbirth;
  newNameCitizenshipDetails.usb_passport.elementConfig.label =
    localizedStrings.applicationpage.passportno;
  newNameCitizenshipDetails.usb_passportexpirydate.elementConfig.label =
    localizedStrings.applicationpage.passportexiprydate;
  newNameCitizenshipDetails.usb_studypermitnumber.elementConfig.label =
    localizedStrings.applicationpage.studyandworkpermitno;
  newNameCitizenshipDetails.usb_studypermitissuedate.elementConfig.label =
    localizedStrings.applicationpage.studypermitissuedate;
  newNameCitizenshipDetails.usb_studypermitexpirydate.elementConfig.label =
    localizedStrings.applicationpage.studypermitexpirationdate;
  newNameCitizenshipDetails.usb_visastatus.elementConfig.options =
    newNameCitizenshipDetails.usb_visastatus.elementConfig.options.map(
      (option) => {
        if (option.value === 943240000) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.canadiancitizen,
          };
        } else if (option.value === 943240001) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.permanentresident,
          };
        } else if (option.value === 943240002) {
          return {
            ...option,
            displayValue:
              localizedStrings.applicationpage.nonresidentworkpermit,
          };
        } else if (option.value === 943240003) {
          return {
            ...option,
            displayValue:
              localizedStrings.applicationpage.nonresidentstudypermit,
          };
        } else if (option.value === 943240004) {
          return {
            ...option,
            displayValue:
              localizedStrings.applicationpage.nonresidentstudypermitminnesota,
          };
        } else if (option.value === 943240005) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.refugee,
          };
        } else if (option.value === 943240006) {
          return {
            ...option,
            displayValue:
              localizedStrings.applicationpage.nonresidentnostudypermit,
          };
        }
        return option;
      },
    );

  newNameCitizenshipDetails.usb_currentstudent.elementConfig.options =
    newNameCitizenshipDetails.usb_currentstudent.elementConfig.options.map(
      (option) => {
        if (option.value === true) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.yes,
          };
        } else if (option.value === false) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.no,
          };
        }
        return option;
      },
    );
  return newNameCitizenshipDetails;
}
export function getTranslationsPage2Address(
  newAddressContactDetails,
  localizedStrings,
) {
  newAddressContactDetails._ses_countryofresidence_value.elementConfig.label =
    localizedStrings.applicationpage.country;
  newAddressContactDetails.address1_line1.elementConfig.label =
    localizedStrings.applicationpage.street;
  newAddressContactDetails.address1_line2.elementConfig.label =
    localizedStrings.applicationpage.streetapt;
  newAddressContactDetails.address1_city.elementConfig.label =
    localizedStrings.applicationpage.city;
  newAddressContactDetails.address1_stateorprovince.elementConfig.label =
    localizedStrings.applicationpage.stateprovince;
  newAddressContactDetails.address1_postalcode.elementConfig.label =
    localizedStrings.applicationpage.postalcode;
  newAddressContactDetails.emailaddress1.elementConfig.label =
    localizedStrings.applicationpage.email;
  newAddressContactDetails.emailaddress3.elementConfig.label =
    localizedStrings.applicationpage.emailaddress2;
  newAddressContactDetails.usb_otherphone.elementConfig.label =
    localizedStrings.applicationpage.otherphone;
  newAddressContactDetails.telephone1.elementConfig.belowText =
    localizedStrings.applicationpage.onlynumerals;
  newAddressContactDetails.telephone1.elementConfig.label =
    localizedStrings.applicationpage.homephone;
  newAddressContactDetails.usb_otherphonenumber.elementConfig.label =
    localizedStrings.applicationpage.otherphonenumber;
  newAddressContactDetails.usb_otherphonenumber.elementConfig.belowText =
    localizedStrings.applicationpage.onlynumerals;
  newAddressContactDetails.usb_otherphone.elementConfig.options =
    newAddressContactDetails.usb_otherphone.elementConfig.options.map(
      (option) => {
        if (option.value === 943240000) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.mobile,
          };
        } else if (option.value === 943240001) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.home,
          };
        } else if (option.value === 943240002) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.office,
          };
        }
        return option;
      },
    );
  return newAddressContactDetails;
}
